module.exports = __webpack_public_path__ + "media/images/lb/107-20c30e4eee8629e11d3657e3b914da90.svg";